import { useRef, useState } from "react";
import { Flex, Box, css, Text, Icon } from "@storyofams/react-ui";
import Image from "next/image";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import AnimatedCarousel from "~components/common/ Dots/AnimatedCarouselDemo";
import { Divider } from "~components/common/Divider";
import { BlackLink } from "~components/common/Icons";
import { Modal } from "~components/common/Modal";
import { RichText } from "~components/common/RichText";
import useMediaQuery from "~hooks/useMediaQuery";

export const NhIngredientCards = ({ content }) => {
  const swiperRef = useRef(null);
  const matchesMobile: boolean = useMediaQuery("(max-width: 769px)");
  const [activeIndex, setActiveIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const dots = !matchesMobile
    ? content.ingredients.slice(0, content.ingredients.length - 2)
    : content.ingredients;
  return (
    <Box
      width="100%"
      id="ingredients-cards"
      css={css({
        width: "100%",
        ".swiper-container": {
          width: "100%",
          borderRadius: "md",
          overflow: "visible",
        },
        "scroll-margin-top": ["50px", "150px"],
        ".product-slider": {},
        ".swiper-slide": {
          width: "auto",
        },
        img: {
          borderTopRightRadius: "md",
          borderTopLeftRadius: "md",
        },
      })}
    >
      <Flex
        justifyContent={["space-between", "center"]}
        alignItems={"center"}
        mb={["14px", 0]}
      >
        <Text
          fontFamily={"DINPro"}
          fontWeight={700}
          fontSize={["36px", "40px"]}
          lineHeight={["43.2px", "48px"]}
          letterSpacing={"0.4px"}
        >
          {content.title}
        </Text>
        <Text
          display={["block", "none"]}
          onClick={() => setIsOpen(true)}
          cursor={"pointer"}
          textDecoration={"underline"}
          fontWeight={600}
          fontSize={"14px"}
        >
          Bekijk alle ingrediënten
        </Text>
      </Flex>

      <Box display={["none", "flex"]} mb={3} justifyContent={"end"}>
        <Text
          onClick={() => setIsOpen(true)}
          cursor={"pointer"}
          textDecoration={"underline"}
          fontWeight={500}
          fontSize={"18px"}
        >
          Bekijk alle ingrediënten
        </Text>
      </Box>
      <Swiper
        onInit={(core: SwiperCore) => {
          swiperRef.current = core.el;
        }}
        slidesPerView={matchesMobile ? 1 : 3}
        spaceBetween={17}
        mousewheel={false}
        autoHeight
        className="product-slider"
        onSlideChange={(e) => {
          setActiveIndex(e.activeIndex);
        }}
      >
        {content.ingredients?.map((item, i) => (
          <SwiperSlide key={item._uid}>
            <Box
              border={"1px solid grey200"}
              borderRadius={"md"}
              position={"relative"}
              flexDirection={"column"}
              display={"flex"}
              height={
                content?.cardsHeight ? content.cardsHeight + "px" : "100%"
              }
            >
              {item.image.filename && (
                <Box
                  flexGrow={0}
                  flexShrink={0}
                  position={"relative"}
                  height={"229px"}
                  maxHeight={"229px"}
                  width={"100%"}
                >
                  <Image
                    objectFit="cover"
                    layout="fill"
                    src={item.image.filename}
                  ></Image>
                </Box>
              )}
              <Box
                display={"flex"}
                flexDirection={"column"}
                height={"100%"}
                p="24px"
                flexGrow={1}
                css={{
                  background: `linear-gradient(180deg, #FFFFFF 35.78%, ${item?.color?.color} 100%)`,
                }}
                borderBottomRightRadius={"md"}
                borderBottomLeftRadius={"md"}
              >
                <Text
                  fontFamily="DINPro"
                  fontWeight={700}
                  fontSize={["20px", "24px"]}
                  lineHeight={["26px", "28.8px"]}
                >
                  {item.title}
                </Text>
                <Text
                  mt={"8px"}
                  fontSize={"16px"}
                  lineHeight={["22.4px", "24px"]}
                  color="#1D1D1BCC"
                >
                  {item.description}
                </Text>
              </Box>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
      <Box
        mt={3}
        width={"100%"}
        alignItems={"center"}
        display={"flex"}
        justifyContent={"space-between"}
      >
        <AnimatedCarousel
          currentPlace={activeIndex}
          totalDots={dots.length}
          initialPlace={0}
          initialSize={10}
          mainColor="black"
          lastPlace={dots.length - 1}
        />
        <Box>
          <Flex fontSize={"28px"}>
            <Icon
              cursor={"pointer"}
              mr={2}
              transform={"rotate(180deg)"}
              icon={BlackLink}
              onClick={() => swiperRef.current.swiper.slidePrev()}
            ></Icon>
            <Icon
              onClick={() => swiperRef.current.swiper.slideNext()}
              cursor={"pointer"}
              icon={BlackLink}
            ></Icon>
          </Flex>
        </Box>
      </Box>
      <Modal isOpen={isOpen} close={() => setIsOpen(false)}>
        <Box p="24px">
          <Text fontWeight={600} fontSize={"28px"}>
            Alle ingrediënten
          </Text>
          <Divider my="8px"></Divider>
          <RichText text={content.modal_text}></RichText>
        </Box>
      </Modal>
    </Box>
  );
};
